module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [(!_vm.packageList.length) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n    無套餐，請新增\n  ")]) : _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-danger m-y-10 inline-block pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    },
    on: {
      "click": _vm.delModalOpen
    }
  }, [_vm._v("\n          刪除\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block pull-right m-r-10",
    on: {
      "click": _vm.gotoCrPackages
    }
  }, [_vm._v("\n          新增\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block pull-right m-r-10",
    attrs: {
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        _vm.show.easy = !_vm.show.easy
      }
    }
  }, [(!_vm.show.easy) ? _c('span', [_vm._v("簡易")]) : _c('span', [_vm._v("進階")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-2 text-left"
  }, [_c('div', {
    staticClass: "bg-light-gray select-element-block ",
    staticStyle: {
      "max-height": "calc(100vh - 396px)",
      "margin-left": "0px",
      "margin-right": "0px",
      "width": "100%"
    }
  }, _vm._l((_vm.packageList), function(package, index) {
    return _c('div', {
      staticClass: "select-element",
      class: {
        'active': _vm.curId === package.item_id
      },
      attrs: {
        "disabled": _vm.isLoad || _vm.curId === package.item_id
      },
      on: {
        "click": function($event) {
          return _vm.clickPackage(package, index)
        }
      }
    }, [_c('span', {
      staticClass: "text-w-600"
    }, [_vm._v(_vm._s(package.name))]), _vm._v(" "), _c('small', {
      staticStyle: {
        "opacity": ".7"
      }
    }, [_vm._v("  " + _vm._s(package.remark))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-10"
  }, [_c('div', {
    staticClass: "box-body form menu-form col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 p-r-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageInfo.name),
      expression: "packageInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "32"
    },
    domProps: {
      "value": (_vm.packageInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.packageInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageInfo.sort),
      expression: "packageInfo.sort"
    }],
    ref: "sort",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.packageInfo.sort)
    },
    on: {
      "keyup": _vm.veritySort,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.packageInfo, "sort", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageInfo.price),
      expression: "packageInfo.price"
    }],
    ref: "price",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.packageInfo.price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPrice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.packageInfo, "price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageInfo.min_limit),
      expression: "packageInfo.min_limit"
    }],
    ref: "minLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "0為無上限",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.packageInfo.min_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMinLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.packageInfo, "min_limit", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "line-height": "38px",
      "width": "20px"
    }
  }, [_vm._v("~")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageInfo.max_limit),
      expression: "packageInfo.max_limit"
    }],
    ref: "maxLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "0為無上限",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.packageInfo.max_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMaxLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.packageInfo, "max_limit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageInfo.remark),
      expression: "packageInfo.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.packageInfo.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.packageInfo, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show.easy),
      expression: "!show.easy"
    }],
    staticClass: "col-xs-12 col-md-6 p-l-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageInfo.price_type),
      expression: "packageInfo.price_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.packageInfo, "price_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("免稅價格")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("含稅價格")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageInfo.description),
      expression: "packageInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.packageInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.packageInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品料號")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageInfo.vendor_custom_id),
      expression: "packageInfo.vendor_custom_id"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.packageInfo.vendor_custom_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.packageInfo, "vendor_custom_id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("選擇區")]), _vm._v(" "), _c('div', {
    staticClass: "form-control text-left",
    staticStyle: {
      "min-height": "60px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block ",
    staticStyle: {
      "position": "absolute",
      "right": "10px",
      "top": "0px",
      "z-index": "3"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#choseModal"
    }
  }, [_vm._v("\n                  選擇選擇區\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "option-left-block"
  }, _vm._l((_vm.blockList), function(block) {
    return (block.active) ? _c('div', {
      staticClass: "inline-block m-r-10 option-chose",
      staticStyle: {
        "margin": "5px"
      }
    }, [_vm._v("\n                    " + _vm._s(block.name) + "\n                  ")]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotoOut
    }
  }, [_vm._v("\n      返回\n    ")]), _vm._v(" "), (!_vm.packageList.length) ? _c('button', {
    staticClass: "btn btn-default btn-black",
    on: {
      "click": _vm.gotoCrPackages
    }
  }, [_vm._v("\n      新增\n    ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkInputEmpty
    }
  }, [_vm._v("\n      儲存\n    ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('c-modal', {
    attrs: {
      "elementList": _vm.blockList,
      "option": _vm.choseOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-block pull-left"
  }, [_c('h4', {
    staticClass: "pull-left"
  }, [_vm._v("\n        套餐\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("套餐名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("排"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("序")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("價"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("格")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("選購數量"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("註")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("價格類型")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("描"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("述")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-633a7ce3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/Temp/CrPackageTemp.vue
// module id = 2453
// module chunks = 1